import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormGroup, FormControl, AbstractControl, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';

import { UserService } from '../user.service';
import { User } from '../user.model';
import { OrganizationService } from '../../organization/organization.service';

let zxcvbn = require('zxcvbn/dist/zxcvbn.js')

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {

  public userId: number;
  public user: User | any;
  public changePasswordState: boolean = false;
  public passwordStrength: number = -1;
  public password_confirm: any;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public userService: UserService,
    public organizationService: OrganizationService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      if (params.user_id) {
        if (params.user_id == 'new') {
          this.user = {};
          this.changePasswordState = true;
        } else {
          this.userId = params.user_id;
          this.organizationService.getUser(this.userId)
            .subscribe((user) => {
              if (user) {
                this.user = new User(user);
              }
            });
        }
      } else {
        this.user = this.userService.userInfo;
      }
    })
  }

  submitForm() {
    let submitSub;
    if (this.user.id) {
      let data = Object.assign(this.user, {});
      data.reset_password = this.changePasswordState;
      submitSub = this.organizationService.updateUser(data)
    } else {
      submitSub = this.organizationService.createUser(this.user)
    }
    submitSub.subscribe((res) => {
      this.router.navigate(['/']);
    })
  }

  downloadConfig(e) {
    e.preventDefault();

		this.organizationService.getVPNConfig(this.user.id).subscribe(response=>{
      console.log(typeof response, response);
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(response));
        element.setAttribute('download', 'user-'+this.user.id+'.ovpn');
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    });
  }

  checkPasswordStrength(event) {
    let check = zxcvbn(event.target.value);
    this.passwordStrength = check.score;
  }

}
